// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"3450f306","163":"64157a3b","690":"6396f546","773":"64157a3b","873":"42d764b1","931":"274c8ec4"}[chunkId] + ".chunk.css";
};